export default __webpack_public_path__ + "static/media/howtouse_basic_03_en.21120b16.png";